/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_ACES_ONLINE_CATEGORIES_CHAP_3 } from './actionTypes';

/**
 * Updates the details in the 'ACESApplyForBenefits' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesOnlineCategoriesChap3Reducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_ONLINE_CATEGORIES_CHAP_3);

/**
 * Updates the indicator of creation of details in the 'ACESApplyForBenefits' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesOnlineCategoriesChap3Reducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_ONLINE_CATEGORIES_CHAP_3);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesOnlineCategoriesChap3ErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_ONLINE_CATEGORIES_CHAP_3);

const reducers = combineReducers({
  fetchAcesOnlineCategoriesChap3: fetchAcesOnlineCategoriesChap3Reducer,

  isFetchingFetchAcesOnlineCategoriesChap3: isFetchingFetchAcesOnlineCategoriesChap3Reducer,
  fetchAcesOnlineCategoriesChap3Error: fetchAcesOnlineCategoriesChap3ErrorReducer,
});

export default { reducers };
